import { SuiBadgeVariant } from '@sui/badge';

/** The web route of the stream; the e-mail and push deep links point at `<route>/{eventId}`. */
export const ALERT_NOTIFICATIONS_ROUTE = '/analytics/alerts-center';

/**
 * Delivery status (`alert_delivery_status`, by alias) -> badge variant, shared
 * by the stream grid's channel columns and the detail pane's delivery rows.
 */
export function alertDeliveryStatusVariant(key: string): SuiBadgeVariant {
  switch (key) {
    case 'sent':
    case 'delivered':
      return 'success';
    case 'failed':
      return 'danger';
    case 'queued':
      return 'info';
    default:
      return 'neutral';
  }
}
